import { useState } from 'react';

import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';

import { DropdownMenuItem } from '../../primitives/dropdown-menu';
import { Switch } from '../../primitives/switch';

interface DropdownMenuItemSwitchProps extends Omit<
  React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.Item>,
  'onClick'
> {
  description?: string;
  label?: {
    checked?: string;
    noChecked?: string;
  };
  checked: boolean;
  onClick: (checked: boolean) => void;
}

export function DropdownMenuItemSwitch({
  description,
  label,
  checked,
  onClick,
  ...props
}: DropdownMenuItemSwitchProps) {
  const [switchChecked, setSwitchChecked] = useState(!checked);

  return (
    <DropdownMenuItem template="grid-icon-content" {...props}>
      <div className="flex justify-center" onClick={(e) => e.preventDefault()}>
        <Switch checked={switchChecked} onCheckedChange={(check) => setSwitchChecked(check)} />
      </div>
      <span className="grid" onClick={() => onClick(switchChecked)}>
        {switchChecked ? (label?.checked ?? 'Activar') : (label?.noChecked ?? 'Desactivar')}
        {!description ? null : <span className="text-xs text-muted-foreground">{description}</span>}
      </span>
    </DropdownMenuItem>
  );
}
